// const baseUrl = "http://192.168.170.85:5003/api/tramites"; //Va comentariado esta linea antes de subir
const baseUrl = "https://api.coop5.com.ar:5003/api/tramites";

class ApiFetch {
  async GET_PUBLIC(endpoint) {
    try {
      const url = `${baseUrl}${endpoint}`;
      const resp = await fetch(url, {
        cache: "no-store", // Deshabilita la caché del navegador
      });
      const data = await resp.json();
      return data;
    } catch (error) {
      throw error;
    }
  }

  async POST_PUBLIC(body, endpoint) {
    try {
      const url = `${baseUrl}${endpoint}`;
      const resp = await fetch(url, {
        method: "POST",
        body,
        headers: {
          "content-type": "application/json",
        },
        cache: "no-store", // Deshabilita la caché del navegador
      });
      const data = await resp.json();
      return data;
    } catch (error) {
      throw error;
    }
  }

  async GET(endpoint) {
    try {
      const store = localStorage?.getItem("coopTramites");
      const token = JSON?.parse(store)?.token;
      const url = `${baseUrl}${endpoint}`;
      const resp = await fetch(url, {
        headers: {
          authorization: `Bearer ${token}`,
        },
        cache: "no-store", // Deshabilita la caché del navegador
      });
      const data = await resp.json();
      return data;
    } catch (error) {
      throw error;
    }
  }

  async POST(body, endpoint) {
    try {
      const store = localStorage?.getItem("coopTramites");
      const token = JSON?.parse(store)?.token;
      const url = `${baseUrl}${endpoint}`;
      const resp = await fetch(url, {
        method: "POST",
        body,
        headers: {
          authorization: `Bearer ${token}`,
          "content-type": "application/json",
        },
        cache: "no-store", // Deshabilita la caché del navegador
      });
      const data = await resp.json();
      return data;
    } catch (error) {
      throw error;
    }
  }

  async DELETE(endpoint) {
    try {
      const store = localStorage?.getItem("coopTramites");
      const token = JSON?.parse(store)?.token;
      const url = `${baseUrl}${endpoint}`;
      const resp = await fetch(url, {
        method: "DELETE",
        headers: {
          authorization: `Bearer ${token}`,
          "content-type": "application/json",
        },
        cache: "no-store", // Deshabilita la caché del navegador
      });
      const data = await resp.json();
      return data;
    } catch (error) {
      throw error;
    }
  }

  async POST_FORMDATA(body, endpoint) {
    try {
      const store = localStorage?.getItem("coopTramites");
      const token = JSON?.parse(store)?.token;
      const url = `${baseUrl}${endpoint}`;
      const resp = await fetch(url, {
        method: "POST",
        body,
        headers: {
          authorization: `Bearer ${token}`,
        },
        cache: "no-store", // Deshabilita la caché del navegador
      });
      const data = await resp.json();
      return data;
    } catch (error) {
      throw error;
    }
  }
}

export default ApiFetch;
